import * as selectors from './progressBar.selectors';
import { progressBarReducerActions } from './progressBar.reducer';

export { default } from './progressBar.reducer';

export const progressBarActions = progressBarReducerActions;
export const progressBarSelectors = selectors;
